const logCodeMapping = {
    CA_PACKAGE_ERROR: "CA001",
};
const logMapping = (logName, env, locale) => {
    const commonAttributes = {
        locale,
        env: (env === null || env === void 0 ? void 0 : env.includes("production")) ? "production" : "dev",
        logCode: logCodeMapping[logName],
        logName,
    };
    switch (logName) {
        case "CA_PACKAGE_ERROR":
        default:
            return Object.assign(Object.assign({}, commonAttributes), { logLevel: "error", message: "CA: Error occured " });
    }
};
const logCustomNR = (logCode, env, locale, additionalInfo) => {
    if ((env === null || env === void 0 ? void 0 : env.includes("production")) || (env === null || env === void 0 ? void 0 : env.includes("sandbox"))) {
        let attributes = logMapping(logCode, env, locale);
        if (typeof additionalInfo in ["boolean", "string", "number"]) {
            attributes = Object.assign(Object.assign({}, attributes), { additionalInfo });
        }
        else if (typeof additionalInfo === "object") {
            attributes = Object.assign(Object.assign({}, attributes), additionalInfo);
        }
        console.info(logCode, { attributes });
        // set the event name in NR
        const pageAction = "chat_anywhere_package";
        if (window && window.newrelic) {
            window.newrelic.addPageAction(pageAction, Object.assign({}, attributes));
        }
    }
    else
        console.info("NR Logging disabled for DEV environment ");
};

// import { loadHPScript } from './loadHelpPanelScript';
const initCA = (tenant, caBottomPlacement) => {
    try {
        if (caBottomPlacement) {
            localStorage.setItem('caBottomPlacement', caBottomPlacement);
        }
        const scriptURL = tenant === 'vcs'
            ? 'https://chat-anywhere.care.vpsvc.com/JS-build/en-us/ca-vistaNext-production-en-us.js'
            : 'https://chat-anywhere.care.vpsvc.com/JS-build/ca-global-controller.js';
        const injectScript = () => {
            const caScript = document.createElement('script');
            caScript.setAttribute('src', scriptURL);
            caScript.onload = () => {
                window.CAScriptLoaded = true;
            };
            caScript.onerror = (event) => {
                logCustomNR('CA_PACKAGE_ERROR', 'production', undefined, {
                    errorName: 'CA Script Load Error',
                    errorMessage: 'onerror Called',
                    errorObject: JSON.stringify(event),
                });
            };
            if (document && document.head && !window.CAScriptLoaded) {
                document.head.appendChild(caScript);
            }
        };
        caBottomPlacement ? setTimeout(injectScript, 3000) : injectScript();
    }
    catch (err) {
        const error = err;
        console.error('Error in loading CHAT ANYWHERE script', err);
        logCustomNR('CA_PACKAGE_ERROR', 'production', undefined, {
            errorName: 'CA Script Load Error',
            error: error.name,
            errorMessage: error.message,
        });
    }
};

export { initCA };
//# sourceMappingURL=index.es.js.map
